import axios from 'axios'

export default {

  namespaced: true,

  actions: {
    async createOrder({ rootState }, payload) {
      const response = await axios.post(`/orders`, {
        ...payload,
        'payment_code': 'WEIXIN',
        'source': 'CHANNEL',
        'uid': rootState.user.id
      })
      if (response) {
        return response.data.data || null
      }
      return null
    }
  }

}
